import { render } from "./ContentPaging.vue?vue&type=template&id=31d5f1b3"
import script from "./ContentPaging.vue?vue&type=script&lang=js"
export * from "./ContentPaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__